<template>

  <div class="selfMenu">
    <template   v-for="(item, index) in routes">
      <router-link v-if="!item.hidden && !item.children"  :to="item.path" :key="index">
        <h-menu-item :name = "item.path">
          <h-icon :name="item.icon"></h-icon>  
          <span>{{ item.name }}</span>
        </h-menu-item>
      </router-link> 
      <router-link v-if="!item.hidden && item.children && item.children.length == 0"  :to="item.path+'/'+item.children[0].path" :key="index">
        <h-menu-item :name = "item.path+'/'+item.children[0].path">
          <h-icon :name="item.icon"></h-icon>  
          <span>{{ item.name }}</span>
        </h-menu-item>
      </router-link> 
      <h-submenu :name="item.name" v-if="!item.hidden && item.children.length > 0" :key="index">
        <template>
            <template  slot="title">
              <h-icon :name="item.icon || 'manage'"></h-icon>
              <span>{{ item.name }}</span>
            </template>
            <template v-for="(child, i) in item.children">
              <template v-if="!child.hidden">
                <sidebar-item v-if="child.children && child.children.length > 0" class="menu-indent nest-menu"  :routes="[child]" :key="i"></sidebar-item>
                <router-link v-else class="menu-indent" :to="item.path+'/'+child.path" :key="i">
                  <h-menu-item :name = "item.path+'/'+child.path">
                    <h-icon name="ios-circle-outline"></h-icon>
                    <span>{{ child.name }}</span>
                  </h-menu-item>
                </router-link>
              </template>
            </template>
        </template>
 
        
      </h-submenu>
    </template>
  
    
  </div>
</template>
<script>
  export default {
    name: 'SidebarItem',
    props: {
      routes: {
        type: Array
      }
    },
    data(){
        return{
        
        }
    },
    mounted(){
    },
    created(){

    }
  }
</script>


// WEBPACK FOOTER //
// src/views/frame/SidebarItem.vue